import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getCityStore = (state: RootState) => state.cityStore;
const getAllUserCity = createSelector(getCityStore, (state) => state.allUserCities);
const getPopularCities = createSelector(getCityStore, (state) => state.popularCities);

export {  getAllUserCity, getPopularCities };
